import adminApiClient from '../../api/base/adminApiClient'

/** 어긋난 모양. 갈래마다 사람이 볼 필요가 다르다. */
export type PlaceNameAuditKind =
  /** 뒤에 지점명이 붙음 — '브리비트' → '브리비트 성수' */
  | 'branch'
  /** 띄어쓰기만 다름 — 글자는 한 자도 안 다르다 */
  | 'spacing'
  /** 앞부분부터 다름 — 사람이 봐야 한다 */
  | 'changed'
  /** 우리 이름이 더 긺 — 대개 우리 쪽이 더 구체적이다 */
  | 'shorter'

export type PlaceNameAuditStatus = 'pending' | 'applied' | 'kept'

export interface PlaceNameAudit {
  place_id: number
  /** 훑을 때 우리가 들고 있던 이름 */
  was: string
  /** 카카오가 그때 부르던 이름 */
  now: string
  /** 지금 DB 에 들어 있는 이름 (그 사이 검색이 바꿨을 수 있다) */
  current_name: string
  kind: PlaceNameAuditKind
  status: PlaceNameAuditStatus
  address: string | null
  kakao_place_id: string | null
  kakao_category: string | null
  /** 카카오 장소 페이지. 직접 눈으로 확인할 때 */
  kakao_url: string
  review_count: number
  save_count: number
  checked_at: string
}

export const adminPlaceNameAuditApi = {
  getPlaceNameAudits: async (params?: {
    kind?: PlaceNameAuditKind
    status?: PlaceNameAuditStatus | 'all'
  }): Promise<{
    audits: PlaceNameAudit[]
    counts: Partial<Record<PlaceNameAuditKind, number>>
  }> => {
    const response = await adminApiClient.get('/admin/place-name-audits', {
      params,
    })
    return response.data
  },

  /**
   * 한 줄을 결정한다.
   *
   * `keep` 도 결정이다 — '봤고 안 바꾸기로 했다'를 남겨야 다시 훑을 때
   * 또 올라오지 않는다.
   */
  decidePlaceNameAudit: async (
    placeId: number,
    decision: 'apply' | 'keep'
  ): Promise<{ place_id: number; name: string; status: string }> => {
    const response = await adminApiClient.post(
      `/admin/place-name-audits/${placeId}`,
      { decision }
    )
    return response.data
  },
}
